import Button from '../../components/UI/Button';

type Props = {
  betAmount: number;
  twoX: any;
  threeX: any;
};

const BetAmount = ({ betAmount, twoX, threeX }: Props) => {
  return (
    <div className="bet-amount">
      <p>Bet Amount:</p>
      <div className="bet-amount__panel">
        <p>{betAmount}</p>
        <div className="bet-amount__multiplier">
          <Button size="unstyled" title="Click to 2x" onClick={twoX}>
            2x
          </Button>
          <Button size="unstyled" title="Click to 3x" onClick={threeX}>
            3x
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BetAmount;
